






















































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import { STATUS } from '@front-app/constants/state';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { Routes } from '@front-app/constants/routes';
import { RequestState } from './Model';

export default defineComponent({
	components: {
		CtaButton,
		FontAwesomeIcon,
	},
	props: {
		requests: {
			required: true,
			type: Array as PropType<RequestState[]>,
		},
		hasCompletedLoading: {
			type: Boolean,
		},
	},
	setup(props) {
		const hasSingleSuccessfulResult = computed(() => props.hasCompletedLoading
			&& props.requests.length === 1
			&& props.requests[0].status === STATUS.SUCCESS);
		const redirectToDiscussionLink = computed(() => {
			if (!hasSingleSuccessfulResult.value) {
				return '';
			}
			const { discussionId, groupId } = props.requests[0];
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			return { name: Routes.GROUP_DISCUSSION, params: { groupId, discussionId } };
		});
		return {
			hasSingleSuccessfulResult,
			redirectToDiscussionLink,
			ButtonPalettes,
			errorStatus: STATUS.ERROR,
			successStatus: STATUS.SUCCESS,
			loadingStatus: STATUS.LOADING,
		};
	},
});
